import React from "react";

const Footer = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <footer className="app-footer">
      <div className="app-footer__container">
        <div className="app-footer__left">
          © {year}, erniee.ai Portal. All rights reserved.
        </div>

        <div className="app-footer__right">
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/security">Security</a>
          <a href="/help">Help</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
